import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({
  value = []
}) => {
  return (
    <div className="flex text-sm mb-5 text-flexi-grey">
      {value.map((item, index) => (
        <React.Fragment key={index}>
          <Link to={item[0]} className="!text-flexi-grey">{item[1]}</Link>
          {(index < value.length - 1) && <span>&nbsp;/&nbsp;</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
